import { isDevEnvironment } from '@web/utils/is-dev-environment';

export default {
    headerHeight: 64,
    qmrHeaderHeight: 72,
    bmisHeaderHeight: 64,
};

// date-fns format
export const DATE_FORMAT = {
    MM_DD_YEAR: 'MM/dd/yyyy',
    MMM_D_YEAR: 'MMM d, yyyy',
    MON_DAY_YEAR: 'PP',
    MON_DAY_YEAR_AT_H_MM: "MMM do, yyyy 'at' h:mm a",
    YYYY_MM_DD: 'yyyy-MM-dd',
};

export const TIME_FORMAT = {
    HH_MM_SS: 'hh:mm:ss',
};

// Attachment upload limit for QMRs / NQRs
export const MAX_ATTACHMENT_COUNT = 50;

// const isDevOrLocalEnvironment = isDevEnvironment();

export const isPrimaryObjectiveEnabled = true; // Enable NQR's;
